import SasEnterpriseAcademyPageProps from 'views/enterprise-academy'
import { getStaticPaths, getStaticProps } from 'views/enterprise-academy/server'
export default SasEnterpriseAcademyPageProps
export { getStaticPaths, getStaticProps }
